import { INACTIVITY_DURATION } from '../config/config';

export const SESSION_DURATION_MINUTES = 15;
export const SESSION_RENEWAL_INTERVAL = 120000; // 2 minutes
export const SESSION_INACTIVITY_THRESHOLD = INACTIVITY_DURATION ?? 28800000; // 8 hours (in ms)
